<ng-container *transloco="let t">
<div class="flex flex-col">
    <div class="flex flex-row relative mb-4">
        <div class="text-3xl">{{location?.name}}</div>
        <button class="absolute right-0" mat-button (click)="close()">X</button>
    </div>

    <div>

        <div class="text-lg mt-4">{{t('text-services')}}</div>
        <hr class="bg-primary w-1/2 mt-0">
        <div *ngFor="let sensor of location?.sensors" class="flex flex-col gap-2">
            <div class="flex flex-row mt-4">
                <div>
                    <mat-icon [svgIcon]="sensor?.icon" class="mt-1"></mat-icon>
                </div>
                <div class="flex flex-col ml-2">
                    <div class="text-md">{{sensor?.name}}</div>
                    <div class="text-sm">{{sensor?.description}}</div>
                </div>
            </div>
        </div>
    </div>

    <div class="flex flex-row justify-end mt-8">
        <button mat-flat-button (click)="close()"
                class="bg-primary text-black">{{t('button-back')}}
        </button>
    </div>

</div>
</ng-container>
